import { Component, OnInit } from '@angular/core';
import { Barcode, BarcodeQuery } from '@fgb/core';
import { BarcodeService } from '@fgb/core';
import { firstValueFrom, Observable } from 'rxjs';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit {
  barcode$: Observable<Barcode>;

  constructor(private barcodeService: BarcodeService, private barcodeQuery: BarcodeQuery) {}

  ngOnInit() {
    firstValueFrom(this.barcodeService.fetchBarcode());
    this.barcode$ = this.barcodeQuery.select();
  }
}
